import type { ReactNode } from 'react';
import type { ButtonProps } from '@components/Button';
import { Spinner } from '@components/Spinner';
import { CheckCircleIcon, RefreshIcon } from '@heroicons/react/outline';
import { PPLSyncStatus } from '@root/@types/types';

interface GetButtonPropsReturn extends Pick<ButtonProps, 'kind' | 'className'> {
  icon: ReactNode;
  text: string;
}

export const getButtonProps = (
  syncStatus?: PPLSyncStatus,
  isLoading?: boolean,
  isDisabled?: boolean,
): GetButtonPropsReturn => {
  if (isLoading) {
    return {
      className: 'h-[34px] bg-info-400 text-white! min-w-[129px] opacity-100!',
      kind: 'secondary',
      icon: <Spinner size="xs" className="mr-1" />,
      text: 'Syncing',
    };
  }

  if (isDisabled) {
    return {
      kind: 'primary',
      icon: <RefreshIcon className="h-5 w-5" />,
      text: 'Sync Data',
    };
  }

  switch (syncStatus) {
    case PPLSyncStatus.AlreadyInSync:
    case PPLSyncStatus.SuccessUpdatedExternal:
    case PPLSyncStatus.SuccessUpdatedLocal:
      return {
        kind: 'green',
        icon: <CheckCircleIcon className="h-5 w-5" />,
        text: 'Sync Data',
      };

    default:
      return {
        kind: 'primary',
        icon: <RefreshIcon className="h-5 w-5" />,
        text: 'Sync Data',
      };
  }
};
